import { FILE_RFR } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState, AppNoApiAction, ActionPayload } from "../../types";

export interface FileRfrState extends BaseAsyncReducerState {
    success: null | boolean;
    response: Record<string, unknown>;
    torfrform?: boolean;
}

// Define an initial state value for the app
const initialState: FileRfrState = {
    loading: false,
    error: false,
    success: false,
    response: {},
    torfrform: false
}

// Create a "reducer" function that determines what the new state
// should be when something happens in the app
function fileRfrReducer(state = initialState, action: AppAction | AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const { payload } = action;

    switch (action.type) {
        case FILE_RFR.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
                success: false,
                torfrform: false
            }
        case FILE_RFR.SUCCESS:
            return {
                ...state,
                ...payload as ActionPayload,
                response: { ...payload as ActionPayload },
                loading: false,
                error: false,
                success: true,
            }
        case FILE_RFR.ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
                success: false,
                torfrform: false
            }
        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default fileRfrReducer;
